import {getRouteApi} from "@tanstack/react-router";

export const supplierContactsRouteApi = getRouteApi(
  "/_app/engineering/suppliers/$supplierId/contacts/",
);
